import React, { forwardRef } from 'react';
import { Box } from '#components/box/box.tsx';
import { GDSCustomizableComponent } from '#src/types.ts';

const DISPLAY_NAME = 'ComposableCardContent';

export interface GDSComposableCardContentProps
  extends GDSCustomizableComponent {
  children: React.ReactNode;
}
export const ComposableCardContent = forwardRef<
  HTMLDivElement,
  GDSComposableCardContentProps
>(
  (
    {
      'data-testid': testId = `GDS-${DISPLAY_NAME}`,
      children,
      className,
      css,
      ...props
    },
    ref?,
  ) => (
    <Box
      className={['GDS-composable-card-content-slot', className].join(' ')}
      css={{
        '&, p': { typography: '$bodyTwo' },
        flex: 0,
        '& > .GDS-vertical-stack-layout': { height: 'auto' },
        ...css,
      }}
      data-testid={testId}
      ref={ref}
      {...props}
    >
      {children}
    </Box>
  ),
);

ComposableCardContent.displayName = DISPLAY_NAME;
